'use client';

import { useModals } from '@/contexts/ModalContext';
import { useTranslations } from 'next-intl';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { useCallback } from 'react';

type Props = {
  onOk?: () => void;
  onAcceptRemove: () => void;
};

export const BeforeRemovingProductModal: React.FC<Props> = ({ onOk, onAcceptRemove }) => {
  const modals = useModals();
  const t = useTranslations('modals');

  const onClose = useCallback(() => {
    onOk?.();
    modals.close(`before-removing-product`);
  }, [modals, onOk]);

  const onClickRemove = useCallback(() => {
    onAcceptRemove();
    modals.close(`before-removing-product`);
  }, [modals, onAcceptRemove]);
  return (
    <AlertDialog open onOpenChange={(open) => !open && onClose()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('beforeRemovingProduct.header')}</AlertDialogTitle>
        </AlertDialogHeader>
        <AlertDialogFooter className='grid grid-cols-2 gap-[8px] w-full mb-[20px]'>
          <AlertDialogAction
            variant='default'
            onClick={onClickRemove}
            className='h-auto p-[15px] w-full gap-[8px] text-white rounded-[8px] text-m'
          >
            {t('beforeRemovingProduct.remove')}
          </AlertDialogAction>

          <AlertDialogCancel
            variant='secondary'
            onClick={onClose}
            className='h-auto p-[15px] w-full gap-[8px] rounded-[8px] bg-bg2-day hover:bg-bg2-day text-m'
          >
            {t('beforeRemovingProduct.cancel')}
          </AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
